import "./policy.css";

const Policy = () => {
  return (
    <>
      <article className="policy">
        <h2 className="policy__main-heading">PRIVACY NOTICE</h2>
        <h3>PRIVACY & COOKIES POLICY</h3>
        <h4>
          Last updated: <span role="time"> November 26, 2022</span>
        </h4>
        <h3>PERSONAL INFORMATION PRIVACY NOTICE</h3>
        <section>
          <h4>PRIVACY NOTICE - OVERVIEW</h4>
          <p>
            Privacy matters to Iwosan Healthcare Systems  Limited (IWIL), so we follow a
            privacy framework that helps us to manage and protect your
            information in our medical services, products, and websites. Whether
            you are new to the hospitals or a long-time user, please take the
            time to get to know our practices – and if you have any questions
            contact us. This Privacy Notice (“Notice”) describes how we collect,
            use, store, handle and secure personal information (sometimes
            referred to as “Personal Information”, “Personally Identifiable
            Information” or “PII) because the Iwosan Healthcare Systems  Limited is
            dedicated to protecting the confidentiality and privacy of
            information entrusted to us by staff, patients, customers and all
            stakeholders. This privacy notice sets out our current policies and
            demonstrates our commitment to privacy.
          </p>
          <p>
            Iwosan Healthcare Systems  Limited is an investment holding company
            dedicated to investing in the Nigerian Healthcare market. Our
            privacy/personal data protection principles are applied based on
            this Privacy Notice at all relevant locations where hosting and
            processing takes place. Our Privacy Notice may be updated from time
            to time, but such update would be reflected on our website. It is
            accepted that your continued use of our online platforms will mean
            that you agree to the changes.
          </p>
        </section>
        <section>
          <h3>PRIVACY NOTICE - SCOPE</h3>
          <p>
            Our Data Protection Policy including this Privacy Notice applies to
            personal information processed by the businesses we own and manage
            as a data controller and as described in this Notice. The Data
            Protection Policy including this Notice explains what information we
            collect about our customers, how we use that information, who we
            share it with, the circumstances under which we may share it and
            what steps are taken to make sure it stays private and secure. The
            policy also clearly outlines the right of customers in respect of
            information collected in the course of business.
          </p>
          <p>
            It is important to know that the policy continues to apply
            notwithstanding the fact that the agreement between IWIL and the
            party using our services ends. It covers every and any service which
            customers (Private, Corporate, HMO) have with IWIL.
          </p>
        </section>
        <section>
          <h3>COLLECTION AND USE OF PERSONAL INFORMATION</h3>
          <h4>WHAT WE COLLECT</h4>
          <p>
            IWIL obtains personal information about you if you choose to provide
            it — for example, to fulfill your request and to provide the
            requested and / or agreed services. By submitting personal
            information to IWIL, you are also acknowledging that IWIL may use
            this information in accordance with its Data Protection Policy
            including this Notice.
          </p>
          <p>
            Your personal information is not used for purposes other than those
            listed in this document, unless we obtain your permission, or unless
            otherwise required by law. In general, we collect and generate the
            following categories of information:
          </p>

          <table>
            <tbody>
              <tr>
                <th>Personal Data</th>
                <td>
                  Such as name, surname, ID card number, face image, gender,
                  date of birth, passport number or other identifiable numbers,
                  Closed circuit television (CCTV) in and around IWIL facilities
                  (these may collect photos or videos of you).
                </td>
              </tr>
              <tr>
                <th>Contact Data</th>
                <td>Such as address, telephone number, e-mail address</td>
              </tr>
              <tr>
                <th>Financial Data</th>
                <td>
                  Such as billing information, credit or debit information,
                  receipt information, invoice information
                </td>
              </tr>
              <tr>
                <th>Marketing Data</th>
                <td>
                  Such as registration information used for subscribe and
                  marketing participation, details of the services we offer and
                  your preferences
                </td>
              </tr>
              <tr>
                <th>Technical Data</th>
                <td>
                  Such as IP Address of computer, type of browser, Cookies
                  information time zone setting, operating system, platform and
                  technology of devices used for accessing website and Online
                  Appointment System
                </td>
              </tr>
              <tr>
                <th>Health Data</th>
                <td>
                  such as treatment information, reports about physical or
                  mental health condition, health cares of service receivers,
                  laboratory test results, diagnosis, diagnostic disease,
                  information about drug use and drug allergy, history of food
                  allergy, blood result, laboratory result, pathological result,
                  radiological images and radiological report, list of
                  prescribed medication, necessary information for medical
                  services, information of feedback and treatments{" "}
                </td>
              </tr>
            </tbody>
          </table>
          <section>
            <h4>SOURCES OF PERSONAL DATA</h4>
            <p>
              IWIL collects and gathers your personal data from the following
              sources
            </p>
            <ul>
              <li>Personal data directly collected from you such as</li>
            </ul>
            <p>
              In case, you receive investigation and treatment, IWIL receives
              your personal data from you contact IWIL about services or you
              self-register at IWIL for receiving medical services and other
              services from IWIL, including registration via electronic media
            </p>
            <ul>
              <li>Personal data indirectly collected from you such as</li>
              <ul>
                <li>
                  Persons who are close to you such as relatives, spouse etc.
                </li>
                <li>
                  Persons you give authority to act on your behalf in contacting
                  with the hospital
                </li>
                <li>
                  Network health providers, in case you already give consent to
                  the network health provider for disclose of your personal data
                </li>
                <li>
                  Person, juristic person or agency of any government, private
                  sector, or state enterprise who refers you for investigation
                  services to IWIL or is a payer for your service expense
                </li>
              </ul>
            </ul>
          </section>
          <section>
            <h4>WHY WE COLLECT IT AND THE LEGAL GROUNDS</h4>
            <p>
              IWIL generally collects only the personal information necessary to
              fulfill your request and to provide the requested and/or agreed
              services. Where additional, optional information is sought, you
              will be notified of this at the point of collection. The
              applicable law allows us to process personal information, so long
              as we have a ground under the law to do so. It also requires us to
              tell you what those grounds are. As a result, when we process your
              personal information, we will rely on one of the following
              processing conditions:
            </p>
            <ul>
              <li>
                <strong>Performance of a contract: </strong>
                This is when the processing of your personal information is
                necessary in order to perform our obligations under a contract
                but also to be able to complete our acceptance procedure so as
                to enter into a contract;
              </li>
              <li>
                <strong>Legal obligation or for public interest: </strong> This
                is when we are required to process your personal information in
                order to comply with a legal obligation, such as keeping records
                for complying with any tax obligations, regulatory purposes, or
                providing information to a public body or law enforcement
                organization;
              </li>
              <li>
                <strong>Legitimate interests: </strong>
                where necessary, we may process information about you where
                there is a legitimate interest for us or a third party with
                respect to your health interests, except where such interests
                are overridden by your interests, fundamental rights and
                freedoms; or you expressly deny.
              </li>
              <li>
                <strong> Consent: </strong>
                We may occasionally ask you for specific permission to process
                some of your personal information for some or more specific
                purposes such as research and studies, and we will only process
                your personal information in this way if you so agree.
              </li>
              <ul>
                <li>
                  <strong>What constitutes consent? </strong>
                  Your consent is given when you consume our services, navigate
                  our website, tick our online forms or boxes, subscribe to our
                  email alerts, and attend our online/offline events and other
                  events, or when you voluntarily submit your personal data to
                  us.
                </li>
                <li>
                  <strong>How do you withdraw your consent? </strong>
                  You may withdraw your consent at any time by unsubscribing to
                  our email alerts or other digital platforms or by contacting
                  the IWIL’s Data Protection Officer (DPO) via{" "}
                  <a href="mailto:privacy@lagoonhospitals.com">
                    privacy@lagoonhospitals.com
                  </a>
                </li>
              </ul>
            </ul>
          </section>
          <h4>RETENTION OF INFORMATION</h4>
          <p>
            We retain your personal information for as long as we have a
            relationship with you, subject to applicable laws and regulation.
            When deciding how long to keep your personal information, we
            consider our legal and regulatory obligations and internal personal
            information management policies. For example, we retain records to
            investigate or defend against potential legal claims or where
            required by law. Where we retain data, we do so in accordance with
            any limitation periods and records retention obligations that are
            imposed by applicable law. Conversely, we will only retain your
            personal data for as long as or until such a time that you request
            and/or exercise your right to deletion/destruction.
          </p>
          <h4>STORAGE AND SECURITY OF INFORMATION</h4>
          <p>
            We implement and maintain organizational, technical, and
            administrative security measures designed to safeguard the
            information we process within our organization against unauthorized
            access, destruction, loss, alteration, or misuse. These measures are
            aimed at providing on-going integrity and confidentiality for your
            personal information. We evaluate and update these measures on an
            ongoing basis. Your information is only accessible to personnel who
            need access to the information to perform their duties, However,
            while we take precautions to safeguard your information, we cannot
            guarantee the security of the networks, systems, servers, devices,
            and databases we operate or that are operated on our behalf.
          </p>
          <h4>SHARING INFORMATION</h4>
          <p>
            We do not share personal information with unaffiliated third
            parties, except if necessary for our legitimate professional and
            business needs, to carry out your requests, and/or as required or
            permitted by law. These include:
          </p>
          <p>
            <strong>Service providers: </strong>
            IWIL works with reputable partners and service providers so they can
            process your personal information on our behalf where required. IWIL
            will only transfer personal information to them when they meet our
            standards set in our policy on the processing of data and security.
            We only share personal information that allows them to provide their
            services.
          </p>
          <p>
            <strong>Courts, law enforcement or regulatory bodies: </strong>
            IWIL may disclose personal information in order to respond to
            requests of courts, government or law enforcement entities or where
            it is necessary to comply with applicable laws, court orders or
            rules, or government regulations.
          </p>
          <p>
            <strong>Audits: </strong>
            Disclosures of personal information may also be needed for data
            privacy or security audits and/or to investigate or respond to a
            complaint or security threat.
          </p>
          <p>
            In addition, IWIL may transfer certain personal information to
            external entities working with us or on our behalf for the purposes
            described in this Notice (e.g. in order to provide you with products
            or services you requested, or due to public or legal duty to do so).
            IWIL will not transfer the personal information you provide to any
            third parties for their own direct marketing use.
          </p>
          <p>
            As such information may be transferred and disclosed to authorities,
            law enforcement, government, persons acting on your behalf, payment
            recipients, beneficiaries, intermediaries, other financial
            institutions, lenders and holders of security over any property
            relevant to IWIL, payment service providers, technology providers,
            support service providers, etc.
          </p>
        </section>
        <section>
          <h4>CHILDREN’S PRIVACY</h4>
          <p>
            Please note that our services apply to children irrespective of age.
            We knowingly collect personally identifiable information from
            Children under the age of 18, under the strict supervision and
            consent of the child’s parent, guardian or legal custodian.
          </p>
        </section>
        <section>
          <h3>COOKIES POLICY</h3>
          <p>
            When you visit our website, IWIL uses cookie to ensure you will
            receive good experience from using the company’s website. Cookie is
            a small file that stores information and records it on to computer
            devices or communication tools when you access via web browser you
            choose while visiting the website.
          </p>
          <p>
            In some instances, IWIL and its service providers use cookies and
            other technologies to automatically collect certain types of
            information when you visit IWIL online platforms, as well as through
            email exchange. The collection of this information allows IWIL to
            customize your online experience, improve the performance and
            security, usability and effectiveness of IWIL’s online presence, and
            to monitor our overall activities. We may collect information about
            your computer or mobile device, including where available operating
            system and browser type, for system administration or for our own
            commercial purposes.
          </p>
          <p>
            Cookies may be placed on your computer or internet-enabled device
            whenever you visit IWIL online. This allows the site to remember
            your computer or device and serves a number of purposes.
          </p>
          <p>
            Your selection will be saved in a cookie and is valid for a short
            period. If you wish to revoke your selection, you may do so by
            clearing your browser’s cookies. Although most browsers
            automatically accept cookies, you can choose whether or not to
            accept cookies via your browser’s settings (often found in your
            browser’s Tools or Preferences menu). You may also delete cookies
            from your device at any time. However, please be aware that if you
            do not accept cookies, you may not be able to fully experience some
            of our web sites’ features.
          </p>
          <p>
            Cookies by themselves do not tell us your email address or otherwise
            identify you personally. In our analytical reports, we may obtain
            other identifiers, but this is for the purpose of identifying the
            number of unique visitors to our web sites and geographic origin of
            visitor trends, and not to identify individual visitors. IWIL may
            also collect and use the geographical location of your computer or
            mobile device. This location data is collected for the purpose of
            providing you with information regarding services which we believe
            may be of interest to you based on your geographic location, and to
            improve our location-based products and services.
          </p>
          <p>
            By navigating on our web sites and accepting cookies or entering
            your login details to access areas reserved for registered users,
            you agree that we can place these cookies on your computer or
            internet enabled device.
          </p>
        </section>
        <section>
          <h3>DATA SUBJECT RIGHTS</h3>
          <p>
            As a personal data owner, you have rights to request IWIL to process
            your personal data according to scope allowed by laws as below
          </p>
          <p>
            Right to withdraw consent: you have rights to withdraw your consent
            for personal data processing as consents to IWIL anytime throughout
            the period your personal data stored at IWIL.
          </p>
          <p>
            Right of access: you have rights to access your personal data and
            request IWIL for a copy of aforementioned personal data, including
            requesting the company to disclose the acquisition of your personal
            data you did not give your consent
          </p>
          <p>
            Right to rectification: you have rights to request IWIL to correct
            incorrect data or add to incomplete data
          </p>
          <p>
            Right to erasure: you have rights to request IWIL to erase your data
            by some reasons (depending on the circumstances and agreements in
            place). We may continue to process your information if another
            legitimate reason for doing so exists
          </p>
          <p>
            Right to restriction of processing: you have rights to request IWIL
            to suppress the use of your personal data by some reasons e.g the
            right to ask us not to process your personal data for marketing
            purposes.
          </p>
          <p>
            Right to data portability: you have rights to transfer your personal
            data maintained by IWIL to other data controllers or yourself by
            some reasons
          </p>
          <p>
            Right to object: you have rights to object your personal data
            processing by some reasons
          </p>
        </section>
        <section>
          <h3>PRIVACY CONCERNS?</h3>
          <p>
            If you have questions, requests, or complaints related to your
            privacy or would like to exercise data protection rights, please
            contact{" "}
            <a
              href="mailto: Privacy@lagoonhospitals.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Privacy@lagoonhospitals.com
            </a>
          </p>
        </section>
      </article>
    </>
  );
};
export default Policy;
